import { render, staticRenderFns } from "./Shipping.vue?vue&type=template&id=1696cd7b&scoped=true"
import script from "./Shipping.vue?vue&type=script&lang=ts"
export * from "./Shipping.vue?vue&type=script&lang=ts"
import style0 from "./Shipping.vue?vue&type=style&index=0&id=1696cd7b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1696cd7b",
  null
  
)

export default component.exports